// Maintenance / informational banner — text fetched from the backend at runtime.
import React, { useEffect, useState } from 'react';
import { appUrl } from '../properties/properties';

const InfoBanner = () => {
  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetch(`${appUrl}/banner`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        setEnabled(!!data.enabled);
        setMessage(data.message || '');
      })
      .catch(() => { /* silent: banner stays hidden if the API is unreachable */ });
    return () => { cancelled = true; };
  }, []);

  if (!enabled || !message) return null;

  return (
    <div className="info-banner">
      <div className='container'>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default InfoBanner;
